var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconData = function SvgIconData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 90.36,
    y1: 470.95,
    x2: 476.69,
    y2: 150.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 90.22,
    y1: 470.79,
    x2: 476.56,
    y2: 150.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 10.57,
    y1: 374.68,
    x2: 396.9,
    y2: 54.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 170.09,
    y1: 567.16,
    x2: 556.42,
    y2: 247.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 19.59,
    y1: 385.55,
    x2: 405.92,
    y2: 65.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -14.79,
    y1: 344.07,
    x2: 371.54,
    y2: 23.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 19.43,
    y1: 385.37,
    x2: 405.76,
    y2: 65.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -16.73,
    y1: 341.74,
    x2: 369.61,
    y2: 21.58,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M250,284.01c-30.18,0-54.65,24.47-54.65,54.65s24.47,54.65,54.65,54.65,54.64-24.45,54.65-54.63c-.02-30.18-24.47-54.64-54.65-54.67ZM250,379.54c-22.58,0-40.89-18.31-40.89-40.89s18.31-40.89,40.89-40.89c22.58,0,40.89,18.31,40.89,40.89v.03c-.04,22.56-18.33,40.83-40.89,40.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.84,402.94l-15.83-19.78c3.31-6.11,5.93-12.57,7.8-19.27l24.99-2.77c3.48-.39,6.12-3.33,6.12-6.84v-32.68c0-3.51-2.63-6.45-6.12-6.84l-25.38-2.81c-1.93-6.41-4.55-12.6-7.8-18.46l15.7-19.61c2.18-2.74,1.96-6.69-.51-9.17l-23.11-23.11c-2.48-2.48-6.42-2.7-9.16-.51l-19.61,15.7c-6.03-3.22-12.38-5.81-18.94-7.73l-2.81-25.21c-.39-3.48-3.34-6.11-6.84-6.12h-32.68c-3.51,0-6.45,2.64-6.84,6.13l-2.8,25.2c-6.67,1.93-13.09,4.61-19.16,7.98l-19.92-15.96c-2.74-2.19-6.69-1.97-9.17.51l-23.1,23.11c-2.48,2.48-2.7,6.43-.51,9.17l15.99,19.97c-3.3,5.96-5.92,12.28-7.8,18.84l-25.18,2.81c-3.48.39-6.12,3.33-6.12,6.84v32.68c0,3.5,2.63,6.45,6.12,6.83l25.18,2.81c1.87,6.56,4.49,12.88,7.8,18.84l-15.99,19.98c-2.19,2.74-1.97,6.69.51,9.17l23.1,23.1c2.48,2.47,6.42,2.69,9.17.51l19.91-15.93c6.07,3.37,12.5,6.05,19.17,7.98l2.8,25.19c.39,3.49,3.33,6.13,6.84,6.13h32.68c3.51,0,6.45-2.64,6.84-6.13l2.81-25.19c6.8-1.97,13.35-4.72,19.53-8.18l19.54,15.6c2.74,2.19,6.69,1.97,9.17-.51l23.1-23.1c2.47-2.48,2.69-6.41.51-9.15ZM318.84,421.11l-16.37-13.1-.76-.9c-2.22-2.65-6.06-3.24-8.98-1.39-7.62,4.88-16.02,8.41-24.84,10.43-3.12.71-5.33,3.48-5.35,6.68l-2.35,22.96h-20.37l-2.35-21.16v-1.82c-.01-3.21-2.25-5.99-5.38-6.68l-.69-.17c-8.33-1.99-16.27-5.33-23.53-9.87-2.51-1.58-5.74-1.37-8.02.52l-18.69,15.04-14.4-14.4,13.61-17.02,1.54-1.99c1.73-2.27,1.88-5.37.39-7.8-4.51-7.21-7.79-15.11-9.7-23.39-.6-2.65-2.71-4.69-5.37-5.21l-2.29-.46c-.19-.04-.38-.07-.58-.09l-21.53-2.39v-20.42l21.9-2.45,2.28-.38c2.75-.46,4.95-2.53,5.57-5.25,1.91-8.32,5.2-16.27,9.74-23.5,1.49-2.43,1.32-5.53-.41-7.8l-15.14-18.94,14.4-14.4,16.71,13.37,1.86,1.58c2.39,2.03,5.85,2.19,8.41.39l.43-.31c7.26-4.44,15.2-7.67,23.49-9.58,3.12-.71,5.34-3.48,5.35-6.68l2.36-22.97h20.37l2.35,21.16v1.82c.01,3.2,2.23,5.97,5.35,6.68,8.54,1.99,16.72,5.32,24.23,9.85,2.61,1.59,5.95,1.27,8.21-.78l18.01-14.55,14.4,14.4-13.53,16.92-.1.12-1.34,1.77c-1.78,2.56-1.7,5.97.19,8.44,4.31,7.05,7.48,14.73,9.39,22.76.73,3.06,3.44,5.23,6.58,5.28l23.25,2.39v20.36l-21.37,2.32-2.07.2c-2.97.28-5.41,2.44-6.06,5.35-1.92,8.62-5.27,16.86-9.93,24.36-1.69,2.74-1.26,6.28,1.05,8.53l14.48,17.82-14.4,14.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.02,338.68c0-3.8-3.09-6.87-6.88-6.87H7.16c-3.8-.15-7,2.8-7.16,6.6-.15,3.8,2.8,7,6.6,7.16.18,0,.37,0,.55,0h94.02c3.78-.02,6.84-3.1,6.84-6.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M492.84,331.77h-94.02c-3.8-.15-7,2.8-7.16,6.6-.15,3.8,2.8,7,6.6,7.16.18,0,.37,0,.55,0h94.02c3.8.15,7-2.8,7.16-6.6.15-3.8-2.8-7-6.6-7.16-.18,0-.37,0-.55,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.1,311.56c3.8,0,6.88-3.07,6.88-6.86,0,0,0,0,0-.01V100.83h211.44v52.03c0,3.8,3.09,6.87,6.88,6.87h51.72v144.95c.15,3.8,3.36,6.75,7.16,6.6,3.58-.14,6.46-3.02,6.6-6.6v-151.76c0-.06,0-.12,0-.18.01-.16.01-.33,0-.49v-.36c0-.12,0-.2-.06-.3s-.06-.27-.09-.4l-.07-.26c0-.13-.09-.27-.14-.4-.02-.08-.05-.15-.08-.22-.06-.13-.12-.27-.18-.39-.03-.08-.07-.15-.11-.22-.07-.13-.14-.26-.22-.39s-.08-.12-.12-.19c-.09-.14-.19-.28-.3-.41-.03-.05-.06-.09-.1-.13-.15-.19-.31-.37-.48-.53l-58.65-58.88c-.17-.17-.35-.32-.52-.48h-.08c-.14-.12-.3-.23-.46-.33l-.2-.12-.38-.23-.22-.1-.39-.18-.22-.09-.41-.14h-.23c-.13,0-.27-.08-.41-.1h-174.4v-33.21h270.04v203.85c.15,3.8,3.36,6.75,7.16,6.6,3.58-.14,6.46-3.02,6.6-6.6V47.29c0-3.8-3.08-6.88-6.88-6.88,0,0-.01,0-.02,0H153.37c-3.8,0-6.87,3.09-6.87,6.88v39.85h-38.4c-3.8,0-6.87,3.08-6.87,6.87v210.68c0,3.8,3.08,6.87,6.87,6.87ZM340.23,110.68l35.17,35.36h-35.17v-35.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.77,142.26h-139.24c-3.8.15-6.75,3.36-6.6,7.16.14,3.58,3.02,6.46,6.6,6.6h139.24c3.8.15,7-2.8,7.16-6.6.15-3.8-2.8-7-6.6-7.16-.18,0-.37,0-.55,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.77,182.6h-67.89c-3.8-.15-7,2.8-7.16,6.6-.15,3.8,2.8,7,6.6,7.16.18,0,.37,0,.55,0h67.89c3.8.15,7-2.8,7.16-6.6.15-3.8-2.8-7-6.6-7.16-.18,0-.37,0-.55,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.48,182.6c-3.8.15-6.75,3.36-6.6,7.16.14,3.58,3.02,6.46,6.6,6.6h32.5c3.8.15,7-2.8,7.16-6.6.15-3.8-2.8-7-6.6-7.16-.18,0-.37,0-.55,0h-32.5Z"
  })));
};
export default SvgIconData;